export const NameObjectCell = ({ value }: { value: { name: string } }) => {
    return <span>{value.name ?? ''}</span>
}
